const japanPrefectures = {
  hokkaido: '홋카이도',
  aomori: '아오모리현',
  iwate: '이와테현',
  miyagi: '미야기현',
  akita: '아키타현',
  yamagata: '야마가타현',
  fukushima: '후쿠시마현',
  ibaraki: '이바라키현',
  tochigi: '도치기현',
  gunma: '군마현',
  saitama: '사이타마현',
  chiba: '치바현',
  tokyo: '도쿄도',
  kanagawa: '가나가와현',
  niigata: '니가타현',
  toyama: '도야마현',
  ishikawa: '이시카와현',
  fukui: '후쿠이현',
  yamanashi: '야마나시현',
  nagano: '나가노현',
  gifu: '기후현',
  shizuoka: '시즈오카현',
  aichi: '아이치현',
  mie: '미에현',
  shiga: '시가현',
  kyoto: '교토부',
  osaka: '오사카부',
  hyogo: '효고현',
  nara: '나라현',
  wakayama: '와카야마현',
  tottori: '돗토리현',
  shimane: '시마네현',
  okayama: '오카야마현',
  hiroshima: '히로시마현',
  yamaguchi: '야마구치현',
  tokushima: '도쿠시마현',
  kagawa: '가가와현',
  ehime: '에히메현',
  kochi: '고치현',
  fukuoka: '후쿠오카현',
  saga: '사가현',
  nagasaki: '나가사키현',
  kumamoto: '구마모토현',
  oita: '오이타현',
  miyazaki: '미야자키현',
  kagoshima: '가고시마현',
  okinawa: '오키나와현'
};

export default japanPrefectures;
